import { gql } from '@apollo/client';

export default gql`
  mutation createBooking(
    $segments: [InputSegment]
    $passengers: [InputPassenger]
    $customer: CustomerInput
    $fulfillmentMethodCode: FulfillmentMethodEnum
    $currency: String
    $contractCode: String
    $language: Language
    $additionalDetails: [InputAdditionalDetails]
  ) {
    createBooking(
      currency: $currency
      segments: $segments
      passengers: $passengers
      customer: $customer
      fulfillmentMethodCode: $fulfillmentMethodCode
      contractCode: $contractCode
      language: $language
      additionalDetails: $additionalDetails
    ) {
      reference
      hotels {
        itemRef
      }
      outboundExtras {
        itemRef
      }
    }
  }
`;
